import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist'

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: 'ef-session',
    storage: localStorage
});

export const store = new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state: {
        usertype: '',
        userdata: null,
        token: '',
        periods: [],
        teacherClasses: [],
        classStudents: []
    },
    mutations: {
        setUserData(state, data) {
            state.token = data.auth_token
            state.usertype = data.userType
            state.userdata = data.userData
            state.isLoggedIn = true
        },
        removeUserData(state) {
            state.periods = [];
            state.token = ''
            state.usertype = ''
            state.userdata = null
        }
    }
});



// WEBPACK FOOTER //
// ./src/store.js